export const FIRST_SHAPES = [
    "rect",
    "roundedRect",
    "circle",
    "triangle",
    "rombus",
    "bubble",
    "RSkewRect",
    "arrowRight",
    "arrowLeft",
];
